var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.125C10.3906 3.125 8.75 5.11719 8.75 7.5C8.75 9.92188 10.3906 11.875 12.5 11.875C14.5703 11.875 16.25 9.92188 16.25 7.5C16.25 5.11719 14.5703 3.125 12.5 3.125ZM14.0625 9.6875C14.0625 9.88281 13.9062 10 13.75 10H11.25C11.0547 10 10.9375 9.88281 10.9375 9.6875V9.0625C10.9375 8.90625 11.0547 8.75 11.25 8.75H11.875V6.60156H11.8359C11.7969 6.64062 11.7188 6.67969 11.6797 6.67969C11.5625 6.67969 11.4453 6.60156 11.4062 6.52344L11.0547 6.01562C11.0156 5.97656 11.0156 5.89844 11.0156 5.82031C11.0156 5.74219 11.0547 5.625 11.1328 5.58594L11.7578 5.19531C11.875 5.07812 12.0703 5 12.2656 5H12.8125C12.9688 5 13.125 5.15625 13.125 5.3125V8.75H13.75C13.9062 8.75 14.0625 8.90625 14.0625 9.0625V9.6875ZM23.75 0H1.25C0.546875 0 0 0.585938 0 1.25V13.75C0 14.4531 0.546875 15 1.25 15H23.75C24.4141 15 25 14.4531 25 13.75V1.25C25 0.585938 24.4141 0 23.75 0ZM23.125 10.625C21.7188 10.625 20.625 11.7578 20.625 13.125H4.375C4.375 11.7578 3.24219 10.625 1.875 10.625V4.375C3.24219 4.375 4.375 3.28125 4.375 1.875H20.625C20.625 3.28125 21.7188 4.375 23.125 4.375V10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.bf3be840d299ccd4160bb54708e31ea3.svg";
export { ForwardRef as ReactComponent };